import {
  Box,
  Text,
  Flex,
  Spacer,
  HStack,
  useTheme,
  Spinner,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import CourseTextButton from "../../../components/buttons/CoursesTextButton";
import SearchBox from "../../../components/searchbox/SearchBox";
import NumberInputLimit from "../../../components/numberInput/NumberInputLimit";
import CustomTable from "../../../components/table/customTable/CustomTable";
import DeletePopup from "../../../components/popups/DeletePopup";
import { useDisclosure } from "@chakra-ui/react";
import AddTopicModal from "../../../components/modals/AddModals/AddTopicModal";
import { useDispatch, useSelector } from "react-redux";
import { getAllTopics } from "../../../store/slice/topicSlice";
const Topic = () => {
  const [editData, setEditData] = useState(null);
  const theme = useTheme();
  const dispatch = useDispatch();

  const { primaryBlue } = theme.colors.pallete;
  const { topics, status } = useSelector((state) => state.topics);
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(5);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    dispatch(getAllTopics());
  }, []);

  const handleAddTopic = () => {
    setEditData(null); // Clear selected topic for adding new
    onOpen();
  };

  // Function to handle Edit Topic button
  const handleEditTopic = (id) => {
    const selectedTopic = topics.find((topic) => topic.id === id);
    if (selectedTopic) {
      setEditData(selectedTopic);
      onOpen();
    }
  };

  const filteredTopics = topics?.filter((course) =>
    course?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box w={"100%"}>
      <Flex>
        <Text fontWeight={500} fontSize={"18px"} color={primaryBlue}>
          Topics
        </Text>
        <Spacer />
        <CourseTextButton text={"Add Topic"} onClick={handleAddTopic} />
      </Flex>
      <Flex mt={"2%"}>
        <HStack spacing={4}>
          <Text fontSize={"14px"}>Show :</Text>
          <NumberInputLimit value={limit} onChange={setLimit} />
        </HStack>

        <Spacer />

        <SearchBox onSearch={setSearchTerm} />
      </Flex>

      <Box overflow={"scroll"}>
        {status === "loading" ? (
          <Box
            height="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner size="md" color="blue.500" />
          </Box>
        ) : (
          <CustomTable
            data={filteredTopics}
            entityType="topic"
            onEdit={handleEditTopic}
            extraColumns={[
              { label: "Subject", key: "subject" },
              { label: "Chapter", key: "chapter" },
            ]}
            limit={limit}
          />
        )}
      </Box>

      <AddTopicModal isOpen={isOpen} onClose={onClose} editData={editData} />
    </Box>
  );
};

export default Topic;
